import React from 'react';
import { DirectoryMapProps } from './DirectoryMap.types';
import * as Styles from './DirectoryMap.styles';
import { useConfig } from '../../contexts/ConfigContext/ConfigContext';
import { wereCookiesAccepted } from '../../helpers/cookies';
import { Wrapper } from '@googlemaps/react-wrapper';
import Map from '../../components/Map/Map';
import StaticMap from '../../components/StaticMap/StaticMap';
import MapMarker from '../../components/MapMarker/MapMarker';

const DirectoryMap: React.FunctionComponent<DirectoryMapProps> = ({ allowCookies = true, mapProps }) => {
  const config = useConfig();
  const cookiesAccepted: boolean = wereCookiesAccepted(allowCookies);
  const resolvedApiKey = mapProps.apiKey || config.googleMapsApiKey || config.nextPublicGoogleMapsApiKey || '';
  const latLong = mapProps.centre.split(',');
  const center: google.maps.LatLngLiteral = {
    lat: parseFloat(latLong[0]),
    lng: parseFloat(latLong[1]),
  };

  return (
    <Styles.Container data-testid="DirectoryMap">
      {cookiesAccepted ? (
        <>
          <Wrapper apiKey={resolvedApiKey}>
            <Map center={center} zoom={mapProps.zoom ?? 14}>
              {mapProps.mapMarkers.map((marker, index) => (
                <MapMarker
                  position={{ lat: marker.lat, lng: marker.lng }}
                  label={marker.label}
                  title={marker.title ?? ''}
                  key={index}
                />
              ))}
            </Map>
          </Wrapper>
        </>
      ) : (
        <StaticMap {...mapProps} apiKey={resolvedApiKey} />
      )}
    </Styles.Container>
  );
};

export default DirectoryMap;
